import {
    createAction,
    createSlice,
    type PayloadAction,
} from '@reduxjs/toolkit';

import type { RootState } from '../root/config.store';
import { type Country, initialState} from '../../types/country';

// slice
export const countrySlice = createSlice({
    name: 'country',
    initialState,
    reducers: {
        fetchAllisLoading(state) {
            state.loading = true;
        },
        fetchAllSucceeded(state, action: PayloadAction<Country[]>) {
            state.data = action.payload;
            state.loading = false;
        },
        fetchAllFailure(state, action: PayloadAction<string>) {
            state.error = action.payload;
            state.loading = false;
        },
    },
});

// Actions
export const countryActions = {
    fetchAll: createAction(`${countrySlice.name}`),
    fetchAllisLoading: countrySlice.actions.fetchAllisLoading,
    fetchAllSucceeded: countrySlice.actions.fetchAllSucceeded,
    fetchAllFailure: countrySlice.actions.fetchAllFailure,
};

// Selectors
export const selectCountry = (state: RootState): Country[] => state.country.data;

// Reducer
export default countrySlice.reducer;